<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import {BIconCaretLeftFill, BIconCaretRightFill, BIconExclamationSquare, BIconExclamationCircleFill} from 'bootstrap-vue'
import systemCode from "@/mixins/systemCode";
import router from "@/mixins/router";
import listDailyReportData from "@/mixins/daily_reports/list_by_factory";
import DatePicker from "vue2-datepicker";

export default {
  name: "ListDailyReportFactory",
  page: {
    title: "作業日報一覧(工場)",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [systemCode, router, listDailyReportData],
  components: {
    Layout,
    BIconExclamationSquare,
    BIconExclamationCircleFill,
    BIconCaretRightFill,
    BIconCaretLeftFill,
    DatePicker
  },
  methods: {
    onChangeSelectedDate(){
      this.getData();
    },
  },
  computed: {
  }
};
</script>
<template>
  <Layout>
    <b-card>
      <div class="d-flex justify-content-center mb-3">
        <div class="fw-bold"><span class="grey p-2 fw-bold mr-2">{{ vendorSiteName }}</span></div>
        <div>
        <span class="h4 mb-2 cursor-pointer">
          <b-icon-caret-left-fill variant="primary" @click="prevDate" v-if="showPrev"/>
        </span>
        </div>
        <div>
          <date-picker
                  lang="ja"
                  :clearable="false"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD（ddd）"
                  value-type="YYYY-MM-DD"
                  position="left"
                  type="date"
                  v-model="filters.date"
                  @change="onChangeSelectedDate"
                >
          </date-picker>
      </div>
      <div>
          <span class="h4 mb-2 cursor-pointer">
          <b-icon-caret-right-fill variant="primary" @click="nextDate" v-if="showNext"/>
        </span>
      </div>
      <div>
        <b-button variant="primary" size="lg" class="mx-5"
        @click="
            redirectRoute(
              'factories',
              {},
              { fromMenu: 0, date: filters.date }
            )
          "
          v-if="showSelectFactory"
        >
          工場選択
        </b-button>
        </div>
      </div>
    </b-card>
    <b-card v-for="(item, index) in data" :key="index">
      <b-row class="mb-2" :id="`schedule_${index + 1}`">
        <b-col cols="3">
          <div class="d-inline-flex">
            <span class="badge mr-0dot5" :style="{'background-color': colorBadge5(item)}">{{ showBadge5(item) }}</span>
            <span class="badge mr-0dot5" :style="{ backgroundColor: getColorBadge7(item, index) + '!important', color:getColorTextBadge7(item, index)}">{{ showBadge7(item, index) }}</span>
            <span class="badge" :style="{ backgroundColor: getColorBadge6(item, index) + '!important', color:getColorTextBadge6(item, index)}">{{ showBadge6(item, index) }}</span>
          </div>
        </b-col>
        <b-col cols="7">
          <template v-if="showDateAlert(item)">
            <span class="h3">
              <b-icon-exclamation-circle-fill variant="danger"/>
            </span>
            <span>
              {{ formatDateAlert(item) }}
            </span>
          </template>
        </b-col>
        <b-col cols="2" class="text-right">
          <button
            class="btn btn-primary w-md waves-effect waves-light"
            @click="
              redirectRoute(
                'daily_reports.input',
                { id: item.id },
                { vendor_site_id: filters.factory_id, zz_vendor_site_4_id: filters.zz_vendor_site_4_id, index: index + 1, 
                  date: filters.date, discharger_site_id: filters.discharger_site_id },
              )
            "
            >
              日報入力
          </button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="1">
          <div class="wrapC">
            <div class="labelC">No</div>
            <div class="contentC">{{ index + 1 }}</div>
          </div>
        </b-col>
        <b-col cols="2">
          <div class="wrapC">
            <div class="labelC">受付番号</div>
            <div class="contentC"><span>{{ item.schedule_id }}</span></div>
          </div>
        </b-col>
        <b-col cols="3">
          <div class="wrapC">
            <div class="labelC">作業指示名</div>
            <div class="contentC"><span>
              <router-link
                v-if="item.work_order_json && item.work_order_json.case"
                :to="{ name: 'projects.sales.instructions.detail', params: { id: item.work_order_json.case.id, work_order_id: item.work_order_json.id  }, query: { readonly: true, daily_report_id: item.id } }"
              >
                {{ item.work_order_json.name }}
              </router-link>
            </span></div>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="wrapC fw-bold">
            <div class="labelC">作業日時</div>
            <div class="contentC"><span v-if="item.schedule">{{ formatHour(item.schedule.start_datetime) }}</span></div>
            <div class="mt-2">～</div>
            <div class="contentC "><span v-if="item.schedule">{{ formatHour(item.schedule.end_datetime) }}</span></div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div class="wrapC">
            <div class="labelC blue">排出事業者</div>
            <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger">{{ item.work_order_json.case.discharger.name }}</span></div>
          </div>
          <div class="wrapC">
            <div class="labelC blue">排出事業場</div>
            <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger_site">{{ item.work_order_json.case.discharger_site.name }}</span></div>
          </div>
          <div class="wrapC" v-if="!isStatus3(item)">
            <div class="labelC blue">運搬事業者</div>
            <div class="contentC">
              <span v-if="item.schedule && item.schedule.vendor">{{ item.schedule.vendor.name }}</span>
            </div>
          </div>
          <div class="wrapC" v-if="otherStatus7and0(item)">
            <div class="labelC blue">処分事業者</div>
            <div class="contentC"><span v-if="vendorName(item)" v-html="vendorName(item)"></span></div>
          </div>
          <div class="wrapC" v-if="otherStatus7and0(item)">
            <div class="labelC blue">処分事業場</div>
            <div class="contentC"><span v-if="vendorSiteNameForList(item)" v-html="vendorSiteNameForList(item)"></span></div>
          </div>
          <div class="wrapC" v-if="item.schedule && item.schedule.assigned_cars_by_schedule">
            <div class="labelC blue">車両</div>
            <div class="contentC"><span v-html="getCars(item.schedule)"></span></div>
          </div>

        </b-col>
        <b-col cols="6">
          <div class="wrapC">
            <div class="labelC">排出事業者住所</div>
            <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger">
              {{ showAddressDischarger(item) }}
            </span></div>
          </div>
          <div class="wrapC">
            <div class="labelC">排出事業場住所</div>
            <div class="contentC"><span v-if="item.work_order_json && item.work_order_json.case && item.work_order_json.case.discharger_site">
              {{ showAddressDischargerSite(item) }}
            </span></div>
          </div>
          <div class="wrapC h-spacer" v-if="!isStatus3(item)">
            <div class="labelC">運搬事業者住所</div>
            <div class="contentC">-</div>
          </div>
          <div class="wrapC" v-if="otherStatus7and0(item)">
            <div class="labelC">処分事業者住所</div>
            <div class="contentC"><span v-html="vendorAddress(item)" v-if="vendorAddress(item)"></span></div>
          </div>
          <div class="wrapC" v-if="otherStatus7and0(item)">
            <div class="labelC">処分事業場住所</div>
            <div class="contentC"><span v-html="vendorSiteAddress(item)" v-if="vendorSiteAddress(item)"></span></div>
          </div>
          <div class="wrapC" v-if="item.schedule && item.schedule.assigned_staffs_by_schedule">
            <div class="labelC">従業員</div>
            <div class="contentC"><span v-html="getStaffs(item.schedule)"></span></div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </Layout>
</template>
<style lang="scss" scoped>
.card-body .badge {
  width: auto;
}
.labelC {
  padding: 10px;
  white-space:nowrap;
  font-weight: bold;
}
.contentC {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
.wrapC {
  margin-bottom: 10px;
  display: flex;
  column-gap: 0.5rem !important;
}
.blue {
  background: #92c4e7;
}
.green {
  background: #a6ddcb;
}
.badge {
  width: 100%;
  padding: 10px;
}
.orange {
  background: #d1885d!important;
}
.mr-10 {
  margin-left: 10px;
}
.grey {
  background: #f8f9fa;
}
.w-3 {
  width: 30%;
}
.mr-0dot5 {
  margin-right: 5px;
}
.text-right {
  text-align: right;
}
</style>
